<template>
  <div class="bank-details">
    <v-divider class="mb-4"></v-divider>
    <div class="d-flex align-center">
      <v-icon left color="primary">mdi-bank-outline</v-icon>
      <span class="subtitle-1 font-weight-bold">Bank Details</span>
    </div>
    <div class="caption grey--text text--darken-1 mb-3">
      <template v-if="editable">
        Commission payouts are made to this account. Optional, but fill all three together.
      </template>
      <template v-else>Only Admin can change bank details.</template>
    </div>

    <v-row v-if="editable || hasAny">
      <v-col md="4" cols="12">
        <v-text-field
          outlined
          :value="form.account_number"
          label="Account Number"
          inputmode="numeric"
          maxlength="18"
          prepend-inner-icon="mdi-bank"
          :readonly="!editable"
          :error-messages="errors.account_number"
          @input="set('account_number', ($event || '').replace(/\D/g, ''))"
        ></v-text-field>
      </v-col>
      <v-col md="4" cols="12">
        <v-text-field
          outlined
          :value="form.ifsc_code"
          label="IFSC Code"
          maxlength="11"
          hint="e.g. SBIN0001234"
          prepend-inner-icon="mdi-bank-transfer"
          :readonly="!editable"
          :error-messages="errors.ifsc_code"
          @input="set('ifsc_code', ($event || '').toUpperCase())"
        ></v-text-field>
      </v-col>
      <v-col md="4" cols="12">
        <v-text-field
          outlined
          :value="form.bank_name"
          label="Bank Name"
          maxlength="100"
          prepend-inner-icon="mdi-office-building"
          :readonly="!editable"
          :error-messages="errors.bank_name"
          @input="set('bank_name', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
    <div v-else class="body-2 grey--text text--darken-1 mb-4">Not added yet.</div>
  </div>
</template>

<script>
// Bank details block for the master franchisee, franchise and franchise staff
// forms. Writes account_number / ifsc_code / bank_name straight onto the
// parent's form object. Only Admin / Super Admin can edit (the API enforces
// the same); everyone else sees the saved values read-only.
export default {
  name: "BankDetailsFields",
  props: {
    form: { type: Object, required: true },
  },
  computed: {
    editable() {
      return this.visible_to(["ADMIN", "SUPER ADMIN"]);
    },
    hasAny() {
      return !!(this.form.account_number || this.form.ifsc_code || this.form.bank_name);
    },
  },
  methods: {
    set(key, value) {
      this.$set(this.form, key, value);
    },
  },
};
</script>
